import { Box, Typography } from '@mui/material';

const helpTextSx = {
  color: 'text.main',
  fontSize: '13px',
  fontWeight: 'normal',
  lineHeight: 1.5,
};

export const HOABusinessClassHelpText = () => {
  return (
    <Box
      sx={{
        width: '100%',
        maxWidth: '600px',
        mb: 3,
      }}
    >
      <Typography sx={helpTextSx}>
        A{' '}
        <Box component='span' sx={{ fontWeight: 'bold' }}>
          Master Association
        </Box>{' '}
        is an homeowners association that governs an entire planned community made up of multiple neighborhoods or
        sub-associations. Sub-associations carry their own separate insurance coverage for the property and exposures
        they own and control.
      </Typography>
      <Typography sx={{ ...helpTextSx, mt: 3 }}>
        A{' '}
        <Box component='span' sx={{ fontWeight: 'bold' }}>
          Single-Family Residential (SFR) Association
        </Box>{' '}
        governs a neighborhood of detached homes and maintains insurance coverage for the common areas and exposures it
        owns and manages; such coverage does not extend to individual residential buildings.
      </Typography>
    </Box>
  );
};
